function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { isArray, isString } from 'vega-util';
import { getFieldDef, isFieldDef, isOrderOnlyDef, vgField } from '../../channeldef';
import { duplicate, getFirstDefined, hash as _hash } from '../../util';
import { sortParams } from '../common';
import { DataFlowNode } from './dataflow';
import { isValidFiniteNumberExpr } from './filterinvalid';
function getStackByFields(model) {
  return model.stack.stackBy.reduce(function (fields, by) {
    var fieldDef = by.fieldDef;
    var _field = vgField(fieldDef);
    if (_field) {
      fields.push(_field);
    }
    return fields;
  }, []);
}
function isValidAsArray(as) {
  return isArray(as) && as.every(function (s) {
    return isString(s);
  }) && as.length > 1;
}
export var StackNode = /*#__PURE__*/function (_DataFlowNode) {
  function StackNode(parent, stack) {
    var _this;
    _classCallCheck(this, StackNode);
    _this = _callSuper(this, StackNode, [parent]);
    _this._stack = stack;
    return _this;
  }
  _inherits(StackNode, _DataFlowNode);
  return _createClass(StackNode, [{
    key: "clone",
    value: function clone() {
      return new StackNode(null, duplicate(this._stack));
    }
  }, {
    key: "stack",
    get: function get() {
      return this._stack;
    }
  }, {
    key: "addDimensions",
    value: function addDimensions(fields) {
      var _this$_stack$facetby;
      (_this$_stack$facetby = this._stack.facetby).push.apply(_this$_stack$facetby, _toConsumableArray(fields));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var out = new Set();
      out.add(this._stack.stackField);
      this.getGroupbyFields().forEach(out.add, out);
      this._stack.facetby.forEach(out.add, out);
      this._stack.sort.field.forEach(out.add, out);
      return out;
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this._stack.as);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Stack ".concat(_hash(this._stack));
    }
  }, {
    key: "getGroupbyFields",
    value: function getGroupbyFields() {
      var _this$_stack = this._stack,
        dimensionFieldDefs = _this$_stack.dimensionFieldDefs,
        impute = _this$_stack.impute,
        groupby = _this$_stack.groupby;
      if (dimensionFieldDefs.length > 0) {
        return dimensionFieldDefs.map(function (dimensionFieldDef) {
          if (dimensionFieldDef.bin) {
            if (impute) {
              // For binned group by field with impute, we calculate bin_mid
              // as we cannot impute two fields simultaneously
              return [vgField(dimensionFieldDef, {
                binSuffix: 'mid'
              })];
            }
            return [
            // For binned group by field without impute, we need both bin (start) and bin_end
            vgField(dimensionFieldDef, {}), vgField(dimensionFieldDef, {
              binSuffix: 'end'
            })];
          }
          return [vgField(dimensionFieldDef)];
        }).flat();
      }
      return groupby !== null && groupby !== void 0 ? groupby : [];
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var transform = [];
      var _this$_stack2 = this._stack,
        facetby = _this$_stack2.facetby,
        dimensionFieldDefs = _this$_stack2.dimensionFieldDefs,
        field = _this$_stack2.stackField,
        stackby = _this$_stack2.stackby,
        sort = _this$_stack2.sort,
        offset = _this$_stack2.offset,
        impute = _this$_stack2.impute,
        as = _this$_stack2.as;
      // Impute
      if (impute) {
        var _iterator = _createForOfIteratorHelper(dimensionFieldDefs),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var dimensionFieldDef = _step.value;
            var _dimensionFieldDef$ba = dimensionFieldDef.bandPosition,
              bandPosition = _dimensionFieldDef$ba === void 0 ? 0.5 : _dimensionFieldDef$ba,
              bin = dimensionFieldDef.bin;
            if (bin) {
              // As we can only impute one field at a time, we need to calculate
              // mid point for a binned field
              var binStart = vgField(dimensionFieldDef, {
                expr: 'datum'
              });
              var binEnd = vgField(dimensionFieldDef, {
                expr: 'datum',
                binSuffix: 'end'
              });
              transform.push({
                type: 'formula',
                expr: "".concat(isValidFiniteNumberExpr(binStart), " ? ").concat(bandPosition, "*").concat(binStart, "+").concat(1 - bandPosition, "*").concat(binEnd, " : ").concat(binStart),
                as: vgField(dimensionFieldDef, {
                  binSuffix: 'mid',
                  forAs: true
                })
              });
            }
            transform.push({
              type: 'impute',
              field: field,
              groupby: [].concat(_toConsumableArray(stackby), _toConsumableArray(facetby)),
              key: vgField(dimensionFieldDef, {
                binSuffix: 'mid'
              }),
              method: 'value',
              value: 0
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      // Stack
      transform.push({
        type: 'stack',
        groupby: [].concat(_toConsumableArray(this.getGroupbyFields()), _toConsumableArray(facetby)),
        field: field,
        sort: sort,
        as: as,
        offset: offset
      });
      return transform;
    }
  }], [{
    key: "makeFromTransform",
    value: function makeFromTransform(parent, stackTransform) {
      var stack = stackTransform.stack,
        groupby = stackTransform.groupby,
        as = stackTransform.as,
        _stackTransform$offse = stackTransform.offset,
        offset = _stackTransform$offse === void 0 ? 'zero' : _stackTransform$offse;
      var sortFields = [];
      var sortOrder = [];
      if (stackTransform.sort !== undefined) {
        var _iterator2 = _createForOfIteratorHelper(stackTransform.sort),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var sortField = _step2.value;
            sortFields.push(sortField.field);
            sortOrder.push(getFirstDefined(sortField.order, 'ascending'));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var sort = {
        field: sortFields,
        order: sortOrder
      };
      var normalizedAs;
      if (isValidAsArray(as)) {
        normalizedAs = as;
      } else if (isString(as)) {
        normalizedAs = [as, "".concat(as, "_end")];
      } else {
        normalizedAs = ["".concat(stackTransform.stack, "_start"), "".concat(stackTransform.stack, "_end")];
      }
      return new StackNode(parent, {
        dimensionFieldDefs: [],
        stackField: stack,
        groupby: groupby,
        offset: offset,
        sort: sort,
        facetby: [],
        as: normalizedAs
      });
    }
  }, {
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var stackProperties = model.stack;
      var encoding = model.encoding;
      if (!stackProperties) {
        return null;
      }
      var groupbyChannels = stackProperties.groupbyChannels,
        fieldChannel = stackProperties.fieldChannel,
        offset = stackProperties.offset,
        impute = stackProperties.impute;
      var dimensionFieldDefs = groupbyChannels.map(function (groupbyChannel) {
        var cDef = encoding[groupbyChannel];
        return getFieldDef(cDef);
      }).filter(function (def) {
        return !!def;
      });
      var stackby = getStackByFields(model);
      var orderDef = model.encoding.order;
      var sort;
      if (isArray(orderDef) || isFieldDef(orderDef)) {
        sort = sortParams(orderDef);
      } else {
        var sortOrder = isOrderOnlyDef(orderDef) ? orderDef.sort : fieldChannel === 'y' ? 'descending' : 'ascending';
        // default = descending by stackFields
        // FIXME is the default here correct for binned fields?
        sort = stackby.reduce(function (s, field) {
          if (!s.field.includes(field)) {
            s.field.push(field);
            s.order.push(sortOrder);
          }
          return s;
        }, {
          field: [],
          order: []
        });
      }
      return new StackNode(parent, {
        dimensionFieldDefs: dimensionFieldDefs,
        stackField: model.vgField(fieldChannel),
        facetby: [],
        stackby: stackby,
        sort: sort,
        offset: offset,
        impute: impute,
        as: [model.vgField(fieldChannel, {
          suffix: 'start',
          forAs: true
        }), model.vgField(fieldChannel, {
          suffix: 'end',
          forAs: true
        })]
      });
    }
  }]);
}(DataFlowNode);